// This module will require the index view and will render it in a root node
// It will probably be replaced by the index redux which will provide the state
import { createElement } from 'react';
import { render } from 'react-dom';

import IndexView from './index_view';
import initApp from './init_app';

document.addEventListener('DOMContentLoaded', () => {
  initApp();

  render(
    createElement(IndexView),
    document.getElementById('root'),
  );
});
